var exports = {
  "x": "xa15a2ab7--5668d2--button",
  "h": "xa15a2ab7--5668d2--modern-button",
};

module.exports = exports;
